import React, { useEffect, useState } from "react";
import { MDBIcon } from "mdbreact";
import {
  Card,
  CardHeader,
  CardBody,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Col,
  Label,
  CardFooter,
  Button,
  Media,
  Form,
  FormGroup,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import { ExportToCsv } from 'export-to-csv';
import axios from "utils/api";
import pageShowing from "utils/pageShowing";
import moment from 'moment';

const searchIcon = {
  position: "absolute",
  zIndex: 2,
  display: "block",
  width: "2.375rem",
  height: "2.375rem",
  lineHeight: "4rem",
  paddingLeft: "2.375rem",
  textAlign: "center",
  color: "#aaa"
};

const searchInput = {
  marginLeft: "20px",
  marginTop: "10px",
  paddingLeft: "3rem",
  width: "100%"
};

const submitButton = {
  marginLeft: "25px",
  marginTop: "10px",
  marginRight: "20px",
  height: "46px"
};

const modalFormMargin = {
  marginTop: "-30px"
}

const imageHeader = {
  borderRadius: '40px'
};

const reportFilter = {
  paddingBottom: "0px",
  textAlign: "center",
  marginTop: "-10px"
};

const Reports = () => {
  const authSession = JSON.parse(localStorage.getItem('auth'));
  const [reportMasters, setReportMasters] = useState({ dataRows: [], dataCount: null, currentPage: 1 });
  const [modalFilter, setModalFilter] = useState(false);
  const [filterReady, setFilterReady] = useState(false);
  const [reportId, setReportId] = useState(0);
  const [reportName, setReportName] = useState('');
  const [includeDate, setIncludeDate] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [queryParameters, setQueryParameters] = useState([]);
  const [page, setPage] = useState({ currentPage: 1, pageSize: 10, totalCount: 0 });
  const [formState, setFormState] = useState({
    values: [],
    arrValues: []
  });
  const pageNumbers = [];
  var [reportErrMsgs, setReportErrMsgs] = useState([``]);

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      getReportMasters('', page.currentPage, page.pageSize);

      var auditlog = {
        moduleName: `Reports`,
        accountId: authSession.merchantGroupCode,
        username: authSession.username,
        actionsTaken: `Viewed reports`
      };

      axios.post('auditlog/add', { auditlog: auditlog }).then((response) => { });
    }

    return () => {
      setReportMasters({});

      mounted = false;
    };
  }, []);

  const handlePageChange = (event) => {
    if (!(event.value < 1 || event.value > pageNumbers[pageNumbers.length - 1])) {
      getReportMasters(searchText, event.value, page.pageSize);

      var auditlog = {
        moduleName: `Reports > Pagination`,
        accountId: authSession.merchantGroupCode,
        username: authSession.username,
        actionsTaken: `Paginate to '${event.value} page'`
      };

      axios.post('auditlog/add', { auditlog: auditlog }).then((response) => { });
    }
  };

  const handleSearchChange = (event) => {
    event.preventDefault();

    setSearchText(event.target.value);

    setPage(page => ({ ...page }));
  };

  const handleSearch = (event) => {
    event.preventDefault();

    setSearchText(event.target.value);

    getReportMasters(event.target.value, page.currentPage, page.pageSize);

    var auditlog = {
      moduleName: `Reports > Search`,
      accountId: authSession.merchantGroupCode,
      username: authSession.username,
      actionsTaken: `Searched '${event.target.value}' in report list`
    };

    axios.post('auditlog/add', { auditlog: auditlog });
  };

  const getReportMasters = (searchValue, currentPage, pageSize) => {
    axios.post(`/reportmaster/get?searchValue=${searchValue}&currentPage=${currentPage}&pageSize=${pageSize}`)
      .then(response => {
        setReportMasters({
          dataRows: response.data.reportMasters,
          dataCount: response.data.totalItems,
          currentPage: currentPage
        });

        setPage(page => ({
          ...page,
          currentPage: currentPage,
          pageSize: pageSize,
          totalCount: response.data.totalItems
        }));
      }).catch(() => {
        console.log('There is a problem fetching the reports. Please try again later.');
      });
  };

  const handleChange = (i, event) => {
    event.persist();

    let values = [formState.values];
    let sessionKey = '';

    values[event.target.id] = event.target.value;

    formState.arrValues.forEach((element, index) => {
      if (element.id.split('^')[1] == event.target.id.split('^')[1]) {
        formState.arrValues.splice(index, 1);
      }
    });

    if (event.target.name.includes('@#UserID')) {
      sessionKey = event.target.name.split('^')[2];
    }

    formState.arrValues.push({
      id: event.target.id,
      dataType: event._targetInst.type,
      value: event.target.value,
      sessionKey: sessionKey
    });

    setFormState(formState => ({
      ...formState,
      values: values
    }));
  };
  const toggle = () => setModalFilter(!modalFilter);

  const dynamicDOM = (parameter, key) => {
    if (parameter.dataType == "Int" || parameter.dataType == "String") {
      return inputText(parameter, key);
    } else if (parameter.dataType == "Date") {
      return inputDate(parameter, key);
    } else {
      return inputSelect(parameter, key);
    }
  }

  const inputText = (parameter, key) => {
    return (
      <FormGroup key={key}>
        <Label for={`${parameter.description}-${parameter.id}`}>{parameter.description}</Label>
        <Input
          type="text"
          name={`${parameter.description.replace(/[\s,]+/g, '')}^${parameter.id}`}
          id={`${parameter.description.replace(/[\s,]+/g, '')}^${parameter.id}`}
          value={formState.values[parameter.description.replace(/[\s,]+/g, '') + '^' + parameter.id]}
          onChange={handleChange.bind(this, key)}
        />
      </FormGroup>
    )
  };

  const inputDate = (parameter, key) => {
    return (
      <FormGroup key={key}>
        <Label for={`${parameter.description}-${parameter.id}`}>{parameter.description}</Label>
        <Input
          type="date"
          name={`${parameter.description.replace(/[\s,]+/g, '')}^${parameter.id}`}
          id={`${parameter.description.replace(/[\s,]+/g, '')}^${parameter.id}`}
          value={formState.values[parameter.description.replace(/[\s,]+/g, '') + '^' + parameter.id]}
          onChange={handleChange.bind(this, key)}
        />
      </FormGroup>
    )
  };

  const inputSelect = (parameter, key) => {
    return (
      <FormGroup key={key}>
        <Label for={`${parameter.description}-${parameter.id}`}>{parameter.description}</Label>
        <Input
          key={key}
          type="select"
          name={`${parameter.description.replace(/[\s,]+/g, '')}^${parameter.id}^${parameter.sessionKey}`}
          id={`${parameter.description.replace(/[\s,]+/g, '')}^${parameter.id}`}
          value={formState.values[parameter.description.replace(/[\s,]+/g, '') + '^' + parameter.id]}
          onChange={handleChange.bind(this, key)}
        >
          {parameter.dataSource.map((data, key) => <option key={key} value={data.id}>{data.description}</option>)}
        </Input>
      </FormGroup>
    )
  };

  const renderEmptyFilter = () => { return ''; };

  const renderQueryFilter = () => {
    if (filterReady) {
      return queryParameters.map((parameter, key) => {
        return (
          dynamicDOM(parameter, key)
        );
      });
    }
  };

  const checkReportFilter = (event, id) => {
    event.preventDefault();

    axios.get(`/reportmaster/getbyid?reportId=${id}&merchantGroupId=${authSession.merchantGroupId}`)
      .then(response => {
        const reportData = response.data.reportMaster;

        setQueryParameters(response.data.queryParameters);
        setReportErrMsgs([``])

        if (reportId != id) {
          formState.arrValues = [];
        }

        if (response.data.queryParameters.length > 0) {
          setModalFilter(true);
          setReportId(reportData.id);
          setReportName(reportData.reportName);
          setIncludeDate(reportData.includeDate);
          setFilterReady(true);
        } else {
          axios.post(`/reportmaster/generate?reportId=${id}&merchantGroup=${authSession.merchantGroupCode}`)
            .then(response => {
              const reportData = response.data.reportData;

              const options = {
                fieldSeparator: ',',
                quoteStrings: '"',
                decimalSeparator: '.',
                showLabels: true,
                showTitle: true,
                title: reportData.reportName,
                useTextFile: false,
                useBom: true,
                useKeysAsHeaders: true,
                filename: reportFileName(reportData.reportName)
              };

              new ExportToCsv(options).generateCsv(reportData);
            }).catch(() => {
              alert('There was a problem generating the report. Please try again later.');
            });
        }

        var auditlog = {
          moduleName: `Reports`,
          accountId: authSession.merchantGroupCode,
          username: authSession.username,
          actionsTaken: `Generated a report for ${reportData.reportName}`
        };

        axios.post('auditlog/add', { auditlog: auditlog }).then(() => { });
      })
  };

  const closeModal = () => {
    setFilterReady(false);

    setModalFilter(false);
  };

  const generateReport = (event) => {
    event.preventDefault();

    setReportErrMsgs([``]);

    // To do. add dynamic validation for reports
    let validReportParams = true;
    let errMsg = [];

    // Daily Transaction Report
    if (reportId == 1) {

      let paramDates = [];
      // check if both date have value
      queryParameters.map((parameter) => {
        let currParamId = parameter.description.replace(/[\s,]+/g, '') + '^' + parameter.id;
        let paramValue = formState.arrValues.find((element) => {
          return element.id === currParamId;
        })?.value;

        paramDates.push(paramValue);

        if (paramValue === undefined || paramValue === ``) {
          validReportParams = false;
          errMsg.push(parameter.description + ` is required.`);
        }
      });

      // check date validity
      if (validReportParams) {
        if (!moment(paramDates[0]).isBefore(moment(paramDates[1]))) {
          validReportParams = false;
          errMsg.push(`Invalid date.`);
        }
      }
    }

    if (!validReportParams) {
      setReportErrMsgs(errMsg);
      return;
    }

    // valid parameters. proceed to generate report    
    var queryParam = [];
    formState.arrValues.forEach((element, index) => {
      queryParam.push({
        id: parseInt(element.id.split('^')[1]),
        dataType: element.dataType,
        value: element.value,
        sessionKey: element.sessionKey
      });
    });

    axios.post(`/reportmaster/generatewithfilter?reportId=${reportId}&merchantGroup=${authSession.merchantGroupCode}&username=${authSession.username}&portaluserid=${authSession?.portalUserId}`, { queryParameters: queryParam })
      .then(response => {
        const reportData = response.data.reportData;

        const options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: true,
          title: reportName,
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true,
          filename: reportFileName(reportName, reportData.includeDate)
        };

        if (reportData === '[]') {
          setReportErrMsgs([`No records found.`]);
          return;
        }

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(reportData);

      }).catch(() => {
        alert('There is a problem generating the report. Please try again later.');
      });
  };

  const reportFileName = (reportName) => {
    let fileName = reportName;

    if (includeDate) {
      fileName = `${reportName}_${moment().format('YYYY-MM-DD')}`;
    }

    return fileName;
  }

  const renderTable = () => {
    return reportMasters.dataRows.map((report) => {
      return (
        <tr key={report.id}>
          <td>{report.paddedId}</td>
          <td>{report.reportName}</td>
          <td>{report.description}</td>
          <td style={{ textAlign: "center" }}>
            <Button
              color="info"
              onClick={event => { checkReportFilter(event, report.id) }}>
              <MDBIcon icon="download" /> Download
            </Button>
          </td>
        </tr>
      );
    });
  };

  const renderPageNumbers = () => {
    if (page.totalCount !== null) {
      let totalPages = Math.ceil(page.totalCount / page.pageSize)
      if (totalPages > 10) {
        let maxPage = 10;
        let minPage = 1;
        if (totalPages >= maxPage) {
          if (reportMasters.currentPage >= maxPage) {
            maxPage = reportMasters.currentPage + 2;
            minPage = reportMasters.currentPage - 2;
          }

          if (minPage < 1)
            minPage = 1;

          if (maxPage >= totalPages)
            maxPage = totalPages;

          if ((maxPage - minPage) < 9)
            minPage = maxPage - 9;

          for (let i = minPage; i <= maxPage; i++) {
            pageNumbers.push(i)
          }
        }
        else {
          if (minPage < 1)
            minPage = 1;
          for (let i = minPage; i <= maxPage; i++) {
            pageNumbers.push(i)
          }
        }
      }
      else {
        for (let i = 1; i <= totalPages; i++) {
          pageNumbers.push(i)
        }
      }
    }

    return pageNumbers.map(number => {
      let classes = reportMasters.currentPage === number ? 'active' : '';
      return (
        <PaginationItem className={classes}>
          <PaginationLink onClick={(e, val) => handlePageChange({ value: number })}> {number} </PaginationLink>
        </PaginationItem>
      );
    });
  };

  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <div className="page-header">
          <h1>Reports</h1>
          <h3>Lists of available reports to generate based on the criteria.</h3>
          <p>
            <MDBIcon icon="link" className="text-green" fixed />
            <a className="text-green" href="/admin/index"> Dashboard</a> / Reports
          </p>
        </div>
        <Container>
          <Row>
            <div className="col">
              <Row>
                <Col md="12" xs="12">
                  <Card className="card-stats mb-4 mb-xl-0 shadow">
                    <CardHeader className="border-0">
                      <h3 className="mb-0">Reports ({reportMasters.dataCount?.toLocaleString()})</h3>
                    </CardHeader>
                    <hr className="mt--0 divider" />
                    <CardBody>
                      <Row className="search-container">
                        <Col sm="12">
                          <div>
                            <FormGroup>
                              <form className="d-flex">
                                <div className="form-group has-search w-100">
                                  <span className="fa fa-search form-control-feedback" style={searchIcon}></span>
                                  <Input className="form-control me-2" style={searchInput}
                                    type="search"
                                    placeholder="Search reports here..."
                                    aria-label="Search"
                                    name="searchValue"
                                    value={formState.searchValue}
                                    onChange={event => handleSearchChange(event)}
                                    onKeyPress={event => { if (event.key === "Enter") { handleSearch(event) } }}
                                    autoComplete="off">
                                  </Input>
                                </div>
                                <Button type="submit" style={submitButton} onClick={event => handleSearch(event)} color="info">SEARCH</Button>
                              </form>
                            </FormGroup>
                          </div >
                        </Col>
                      </Row>
                      <Table className="align-items-center table-flush" responsive>
                        <thead className="thead-light">
                          <tr>
                            <th rowSpan="2">Report Number</th>
                            <th rowSpan="2">Report Name</th>
                            <th rowSpan="2">Description</th>
                            <th rowSpan="2" className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            reportMasters.dataCount !== 0 ? renderTable() :
                              <tr>
                                <td colSpan="7" style={{ textAlign: 'center' }}>
                                  <Label size="sm" className="mr-sm-2">
                                    <i>
                                      <MDBIcon icon="exclamation-triangle" /> No data available in the table.
                                    </i>
                                  </Label>
                                </td>
                              </tr>
                          }
                        </tbody>
                      </Table>
                      <CardFooter className="py-4">
                        <Row className="mt-0" hidden={!(Math.ceil(page.totalCount / page.pageSize) > 1)}>
                          <Col xl="6" l="6">
                            {pageShowing(page.totalCount, page.pageSize, page.currentPage)}
                          </Col>
                          <Col xl="6">
                            <Pagination className="pagination justify-content-end mb-0" listClassName="justify-content-end mb-0">
                              <PaginationItem>
                                <PaginationLink
                                  onClick={() => handlePageChange({ value: (page.currentPage - 1) })}
                                  tabIndex="-1"
                                >
                                  <i className="fas fa-angle-left" />
                                  <span className="sr-only">Previous</span>
                                </PaginationLink>
                              </PaginationItem>
                              {renderPageNumbers()}
                              <PaginationItem>
                                <PaginationLink
                                  onClick={() => handlePageChange({ value: (page.currentPage + 1) })}
                                  tabIndex="-1"
                                >
                                  <i className="fas fa-angle-right" />
                                  <span className="sr-only">Next</span>
                                </PaginationLink>
                              </PaginationItem>
                            </Pagination>
                          </Col>
                        </Row>
                      </CardFooter>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          </Row>
        </Container>
      </div>

      <Modal isOpen={modalFilter} toggle={toggle} backdrop={false} size="md" centered>
        <ModalHeader style={reportFilter}>
          <p style={{ textAlign: "center" }}>
            <Media object width="100" style={imageHeader} src={require("assets/img/brand/report.png")} alt="Change password" />
          </p>
          <div className="text-center mb-4" style={{ fontWeight: "500", fontSize: "20px" }}>
            {`Download Report - ${reportName}`}
          </div>
          <div className="text-center text-muted mb-4" style={{ marginTop: "-20px", fontSize: "16px" }}>
            <small>Filter your report extraction to show only record based on the selected criteria.</small>
          </div>
          <hr className="mt--3 divider" />
        </ModalHeader>
        <ModalBody>
          <Form style={modalFormMargin}>
            {!filterReady ? renderEmptyFilter() : renderQueryFilter()}
          </Form>
          {/* <Label className="red-asterisk">{reportErrorMessage}</Label> */}
          {reportErrMsgs?.map((err) => {
            if (err != ``) {
              return (
                <p className="red-asterisk">{err}</p>
              );
            }
          })}
          {/* {reportErrorMessage} */}
        </ModalBody>
        <ModalFooter style={modalFormMargin}>
          <Button color="info" onClick={event => { generateReport(event) }}>
            <MDBIcon icon="download" /> Download
          </Button>{' '}
          <Button color="secondary" onClick={closeModal}>Close</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default Reports;
